import React, { useEffect, useState } from 'react';
import TableCrud from '../../components/TableCrud';
import Api, { exceptionNotificationAPI } from '../../services/api';

const RegionFormIndex = () => {
    const [isVisible, setIsVisible] = useState(true);

    const columns = [
        {
            label: "Nome",
            name: "name"
        },
        {
            label: "Empresa",
            name: "tenant.name",
            visible: isVisible
        },
        {
            label: "Ativo",
            name: "isActive"
        }
    ]

    return (
        <TableCrud title={"Região"} table={"region"} columns={columns}/>
    );
}

export default RegionFormIndex;
